import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const anodot = defineConnector({
  identifier: "anodot",
  name: "Anodot",
  tagLine: "Autonomous business monitoring",
  logo,
  protocol: "http",
  tags: ["observability", "data"],
  defaultUrlPattern: () => "https://app\\.anodot\\.com/api/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://app.anodot.com/api/v2/access-token",
        method: "POST",
        jsonBody: {
          refreshToken: app.secret.refreshToken,
        },
      },
      extract: {
        from: "jsonPath",
        paths: ["access_token"],
        fallbackToRawBody: true,
      },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Generate a refresh token",
      items: [
        {
          kind: "markdown",
          content:
            "In Anodot, open **User Settings → API Access** and generate a refresh token. See the [Anodot API reference](https://support.anodot.com/hc/en-us/articles/360002631278).",
        },
        {
          kind: "input",
          label: "Refresh token",
          required: true,
          target: { kind: "secrets", field: "refreshToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://app.anodot.com/api/v2/stream-schemas/schemas",
  },
});
